import { enableProdMode, PLATFORM_ID } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// @ts-expect-error
import moengage from '@moengage/web-sdk';
import { isPlatformBrowser } from '@angular/common';

if (environment.production) {
   enableProdMode();
}

platformBrowserDynamic()
   .bootstrapModule(AppModule)
   .then((moduleRef) => {
      const isBrowser = isPlatformBrowser(moduleRef.injector.get(PLATFORM_ID));

      if (isBrowser) {
         setTimeout(() => {
            import('branch-sdk')
            .then((branch: any) => {
                  (branch.default || branch).init(environment.branchKey);
               })
               .catch((err: any) => console.error('Branch SDK failed to load', err));

            moengage.initialize({
               app_id: environment.moengageAppId,
               cluster: 'DC_2',
               debug_logs: environment.moengageDebugLogs,
            });
         }, 100); // Delays execution slightly
      }
   })
   .catch((err: any) => console.error(err));

// window.addEventListener('MOE_AUTOMATED_EVENTS', function (event: any) {
//    if (
//       event.detail.name === 'MOE_ONSITE_MESSAGE_CLICKED' &&
//       event.detail.data &&
//       event.detail.data.length
//    ) {
//       // console.log(event.detail.data);
//    }
// });
